import * as React from 'react'
import { SandpackCodeEditor, SandpackLayout, SandpackPreview, SandpackProvider, useSandpack } from "src/assets/lib/@codesandbox/sandpack-react";
import "src/assets/lib/@codesandbox/sandpack-react/dist/index.css";
import { useState } from 'react'

const SimpleCodeViewer = (props) => {
  const { sandpack } = useSandpack();
  const { files, activePath } = sandpack;

  const code = files[activePath].code;
  const onClick = () => {
    props.click(files);
  }

  return <div className='tsx-btn-container'><button className='btn btn-secondary tsx-btn'
    id='saveCodeBtn'
    onClick={onClick}
  >Save Code</button></div>;
};

const MyReactComponent = (props, state) => {
  const [text, setText] = useState('First text');
  const template = props.template;
  const userInputSetup = props.files
    ? {
      ...props.customSetup,
      files: {
        ...props.customSetup?.files,
        ...props.files,
      },
    }
    : props.customSetup;

  const onClick = (d) => {
    props.callback(d);
  }

  const triggerClick = () => {
    console.log('click triggered');
  }

  return (
    <>
      <SandpackProvider template={template} customSetup={userInputSetup} >
        <SandpackLayout theme={'light'}>
          <SimpleCodeViewer className='tsx-code-viewer' click={onClick} />
          <SandpackCodeEditor
            showTabs
            showLineNumbers
            showInlineErrors
            wrapContent
            closableTabs


          />

          <SandpackPreview
            showNavigator
            showRefreshButton
            showSandpackErrorOverlay
            showOpenInCodeSandbox={false}
          />

        </SandpackLayout>
      </SandpackProvider>
    </>
  )
}



export default MyReactComponent;
